import { render, staticRenderFns } from "./TutorialManagement.vue?vue&type=template&id=696c24db&scoped=true&"
import script from "./TutorialManagement.vue?vue&type=script&lang=js&"
export * from "./TutorialManagement.vue?vue&type=script&lang=js&"
import style0 from "./TutorialManagement.vue?vue&type=style&index=0&id=696c24db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c24db",
  null
  
)

export default component.exports